/**
 * Gutenberg Block JS
 *
 * Import JS for Gutenberg blocks.
 */

// Allowed Blocks
import './block-editor';

// Custom Gutenberg Blocks.
// import './wd';
// import './acf';
